export default __webpack_public_path__ + "static/media/red-exclamation.1ec09ad4.svg";